var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9159 0.0869154C16.6372 0.557301 0.878163 6.61153 0.646051 6.72157C-0.12524 7.08714 -0.215409 7.57 0.426675 7.8966C0.488667 7.92812 1.55534 8.26923 2.79705 8.65463L5.05475 9.35532L10.1813 6.1484C13.0009 4.38456 15.3646 2.92163 15.434 2.89747C15.6081 2.83676 15.7579 2.84243 15.8279 2.91239C15.8768 2.96134 15.8789 2.98591 15.8399 3.05786C15.8142 3.10546 13.9418 4.80584 11.6791 6.83647C9.41642 8.86709 7.55903 10.5444 7.55156 10.5639C7.54412 10.5833 7.46759 11.5971 7.38147 12.8168L7.22495 15.0343L7.39504 15.0114C7.48859 14.9988 7.63673 14.9505 7.72423 14.9041C7.81177 14.8577 8.40084 14.3241 9.03335 13.7183C9.66581 13.1125 10.2052 12.6084 10.232 12.5981C10.2588 12.5879 11.266 13.3013 12.4703 14.1836C13.6745 15.0659 14.7542 15.8314 14.8696 15.8847C15.1721 16.0245 15.5129 16.0383 15.7342 15.9199C15.9319 15.8141 16.1251 15.5513 16.2064 15.2777C16.2378 15.1718 16.9263 11.9907 17.7364 8.20851C19.0851 1.91143 19.2092 1.30177 19.2097 0.974938C19.2101 0.666144 19.1973 0.592693 19.1146 0.430162C19.0562 0.315571 18.9567 0.198576 18.8595 0.130197C18.6372 -0.0261726 18.2691 -0.0430419 17.9159 0.0869154Z",
    fill: "#181B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.61190548eeab4b30f34500e9015a8320.svg";
export { ForwardRef as ReactComponent };